namespace Solovis.Reports.ReportHelpers.AttributionReport {

  export interface AttributionEffectsColumnVisibility {
    showInteractionEffect: boolean;
    showLineItemBenchmarkEffect: boolean;
  }

  /**
   * Resolves whether the attribution table's conditional Interaction Effect / Line Item
   * Benchmark Effect columns should show, from the Attribution Report's "attribution" (modal-1)
   * parameter.
   *
   * showInteractionEffect checks for "standalone" specifically (not just any interactionEffect
   * value) because that's the only wire value (see interactionEffectToStatSetOptions in
   * AttributionReport.js) for which the server populates TotalInteractionEffect at all --
   * "withSelection"/"withAllocation" fold interaction into selection/allocation instead.
   *
   * AR-004 (the KPI tiles, not yet implemented in this codebase) will need this exact same check
   * for its own Interaction Effect % / Line Item Benchmark Effect % tiles, so that report area and
   * this table never disagree on whether a given effect is shown (AR-006-2 AC/edge cases). Whoever
   * implements AR-004 should call this function rather than re-deriving the condition.
   */
  export function resolveAttributionEffectsColumnVisibility(attribution: any): AttributionEffectsColumnVisibility {
    const attributionToUse = attribution || {};

    return {
      showInteractionEffect: attributionToUse.interactionEffect === "standalone",
      showLineItemBenchmarkEffect: !!attributionToUse.includeLineItemBenchmarkEffect
    };
  }
}
